import { ILayoutWithOwner, ILayoutWithRowId } from '../../factories/layout-factory';
import { useActionButton } from '../../hooks/action-button/useActionButton';
import { IActionLayout } from '../../types/layout/action';

function ActionButton(props: IActionLayout & ILayoutWithOwner & ILayoutWithRowId) {
    const { className, disabled, title } = props;

    const { executeAction, loading } = useActionButton(props);

    return (
        <button disabled={disabled} type="button" className={className || 'btn btn-primary'} onClick={executeAction}>
            <div className="spinner-border spinner-border-sm mr-2" role="status" hidden={!loading} />
            {title}
        </button>
    );
}

export default ActionButton;
